<div class="buttonbar" [formGroup]="form">
  <app-service-response [responseMessages]="responseMessages"></app-service-response>
  <sc-flex [stretchContent]="true">
    <button class="cancel-movement-btn" mat-flat-button [disabled]="!movingOrderCancable"
      (click)="cancelOngoingMovementOrder()">
      {{'Rangierauftrag' | translate:['tmc-yard.action-tablet.transport-details.action.cancel-movement-order-line1',
      translationService.language]}}
      <br />
      {{'stornieren' | translate:['tmc-yard.action-tablet.transport-details.action.cancel-movement-order-line2',
      translationService.language]}}
    </button>

    <sc-content-spacer [grow]="true"></sc-content-spacer>

    <ng-container *ngIf="defaultCompletionOption?.type === 'NO_FURTHER_PROCESSING'">
      <sc-select-field labelDictionaryKey="tmc-yard.entity.moving-order.movementStrategy.label" [data]="strategySelectionItems"
        formControlName="movementStrategy"></sc-select-field>

      <sc-content-spacer></sc-content-spacer>

      <button class="forward-to-process-btn" mat-flat-button (click)="forwardToProcess()"
        [disabled]="!createMovementEnabled">
        {{'Weiterleiten' |
        translate:['tmc-yard.action-tablet.transport-details.action.create-movement-order-forward-to-process-line1',
        translationService.language]}}
        <br />
        {{'an Proesss' |
        translate:['tmc-yard.action-tablet.transport-details.action.create-movement-order-forward-to-process-line2',
        translationService.language]}}
      </button>

      <sc-content-spacer></sc-content-spacer>

      <button class="create-movement-btn" mat-flat-button [disabled]="!createMovementEnabled"
        (click)="completeNoFurtherProcessing()">
        {{'complete on ' | translate:['tmc-yard.action-tablet.transport-details.action.complete-no-further-processing',
        translationService.language]}}
      </button>
    </ng-container>

    <ng-container *ngIf="defaultCompletionOption?.type === 'COMPLETE_ON_WAITING_AREA'">

      <button class="forward-to-process-btn" mat-flat-button (click)="forwardToProcess()"
        [disabled]="!createMovementEnabled">
        {{'Weiterleiten' |
        translate:['tmc-yard.action-tablet.transport-details.action.create-movement-order-forward-to-process-line1',
        translationService.language]}}
        <br />
        {{'an Proesss' |
        translate:['tmc-yard.action-tablet.transport-details.action.create-movement-order-forward-to-process-line2',
        translationService.language]}}
      </button>

      <sc-content-spacer></sc-content-spacer>

      <button class="create-movement-btn" mat-flat-button [disabled]="!createMovementEnabled"
        (click)="commpleteOnWaitingArea()">
        {{'complete on ' |
        translate:['tmc-yard.action-tablet.transport-details.action.create-movement-order-waitingarea-line1',
        translationService.language]}}
        <br />
        {{'waiting area' |
        translate:['tmc-yard.action-tablet.transport-details.action.create-movement-order-waitingarea-line2',
        translationService.language]}} {{targetName}}
      </button>
    </ng-container>

    <ng-container *ngIf="defaultCompletionOption?.type === 'FORWARD_TO_NEXT_PROCESSING_STATION'">

      <button class="create-movement-btn" mat-flat-button [disabled]="!createMovementEnabled"
        (click)="forwardToNextProcessingStation()">
        {{'finsish processing' |
        translate:['tmc-yard.action-tablet.transport-details.action.create-movement-order-line1',
        translationService.language]}}
        <br />
        {{'finsish processing' |
        translate:['tmc-yard.action-tablet.transport-details.action.create-movement-order-line2',
        translationService.language]}} {{targetName}}
      </button>
    </ng-container>

  </sc-flex>
</div>